<template>
  <div class="background bg-dark">
    <h3 style="color: #fff">Coloured Bubbles</h3>
    <h1 style="color: #ff6688">Click to view!</h1>

    <!-- Buttons to switch ripple colors -->
    <div>
      <button
        v-for="color in colors"
        :key="color"
        @click="setRippleColor(color)"
        :style="{
          backgroundColor: color,
          width: '40px',
          height: '40px',
          border: 'none',
          borderRadius: '50%',
          margin: '10px',
          cursor: 'pointer',
        }"
      ></button>
      <!-- <button
        key="Random"
        @click="setRandomColor"
        style="
          width: 40px;
          height: 40px;
          background-color: gray;
          border: none;
          border-radius: 50%;
          margin: 10px;
          cursor: pointer;
        "
      ></button> -->
    </div>

    <div
      id="rippleapp"
      class="background"
      @click="createRipple($event)"
      style="position: relative; width: 100%; height: 100vh"
    >
      <div
        v-for="ripple in ripples"
        :key="ripple.id"
        class="ripple"
        :style="{
          left: `${ripple.x}px`,
          top: `${ripple.y}px`,
          width: `${ripple.size}px`,
          height: `${ripple.size}px`,
          background: ripple.color /* Dynamic ripple color */,
          animation: `ripple-animation 2s ease-out forwards`,
        }"
      ></div>
    </div>
  </div>
</template>

<style scoped>
.background {
  background-color: #343a40;
  margin: 0;
  overflow: hidden;
  position: relative;
}

#rippleapp {
  position: relative;
  width: 100%;
  height: 100vh;
}

.ripple {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}

/* Keyframes for ripple animation */
@keyframes ripple-animation {
  0% {
    transform: scale(0);
    opacity: 0.6;
  }
  100% {
    transform: scale(6);
    opacity: 0; /* Fade out */
  }
}
</style>

<script>
export default {
  data() {
    return {
      ripples: [], // Array to store all active ripples
      idCounter: 0, // Unique ID for each ripple
      rippleColor: "rgba(255, 0, 0, 0.5)", // Default color (Red)
      colors: [
        "rgba(255, 0, 0, 0.5)", // Red
        "rgba(0, 255, 0, 0.5)", // Green
        "rgba(0, 0, 255, 0.5)", // Blue
        "rgba(255, 255, 0, 0.5)", // Yellow
        "rgba(255, 165, 0, 0.5)", // Orange
        "rgba(0, 255, 255, 0.5)", // Cyan
        "rgba(255, 0, 255, 0.5)", // Magenta
        "rgba(128, 0, 128, 0.5)", // Purple
        "rgba(255, 105, 180, 0.5)", // Hot Pink
        "rgba(255, 215, 0, 0.5)", // Gold
        "rgba(240, 240, 240, 0.5)", // gray
        "rgba(0, 0, 0, 0.5)", // black
      ],
    };
  },
  methods: {
    createRipple(event) {
      const rippleApp = document.getElementById("rippleapp");
      const rect = rippleApp.getBoundingClientRect(); // Get position and size of the container
      const size = Math.random() * 50 + 30; // Ripple size (random between 30px to 80px)

      // Calculate mouse position relative to the container
      const x = event.clientX - rect.left - size / 2;
      const y = event.clientY - rect.top - size / 2;

      // Create a new ripple object
      const newRipple = {
        id: this.idCounter++,
        x: x,
        y: y,
        size,
        color: this.rippleColor, // Use the current ripple color
      };

      // Add ripple to the list
      this.ripples.push(newRipple);

      // Remove ripple after animation completes (to clean up the DOM)
      setTimeout(() => {
        this.ripples = this.ripples.filter(
          (ripple) => ripple.id !== newRipple.id
        );
      }, 2000); // Time matches the animation duration
    },

    // Set the ripple color (called by the color buttons)
    setRippleColor(color) {
      this.rippleColor = color;
    },

    // Set a random ripple color
    setRandomColor() {
      const randomIndex = Math.floor(Math.random() * this.colors.length);
      this.rippleColor = this.colors[randomIndex];
    },

    // Mix two random colors for a new ripple color
    mixColor() {
      const color1 =
        this.colors[Math.floor(Math.random() * this.colors.length)];
      const color2 =
        this.colors[Math.floor(Math.random() * this.colors.length)];

      // Extract RGB values from the colors and mix them
      const [r1, g1, b1] = color1.match(/\d+/g).map(Number);
      const [r2, g2, b2] = color2.match(/\d+/g).map(Number);

      // Mix colors by averaging RGB components
      const mixedColor = `rgba(${Math.floor((r1 + r2) / 2)}, ${Math.floor(
        (g1 + g2) / 2
      )}, ${Math.floor((b1 + b2) / 2)}, 0.5)`;

      this.rippleColor = mixedColor;
    },
  },
};
</script>
